module.exports = __webpack_public_path__ + "static/media/front.1060a76f.jpg";